<template>
  <div :id="id" class="modal fade" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-pdf">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button-new @confirmed="close" />
          <h4 class="modal-title">{{ $t("global.importfile") }}</h4>
        </div>
        <div class="modal-body">
          <div class="col-xl-12">
            <div class="mr-2" style="min-width: 9%">
              <div class="form-group">
                <label>{{ $t("global.documenttype") }}</label>
                <v-select
                  v-model.trim="dokumentKategorieId"
                  :options="dokumentKategorien"
                  :reduce="(r) => r.id"
                  label="bezeichnung"
                  :placeholder="$t('global.categories')"
                  style="z-index: 15"
                >
                  <span slot="no-options">
                    {{ $t("global.taptosearch") }}
                  </span>
                </v-select>
              </div>
            </div>
            <div class="form-group text-center">
              <vue-2-dropzone
                id="dropzone"
                ref="dokumenteUpload"
                class="dropzone-white dropzone-small vue-dropzone dropzone dz-clickable"
                :options="dropzoneOptions"
                @vdropzone-success="fileUploaded"
              ></vue-2-dropzone>
              <button class="btn btn-primary mt-2" @click="uploadFiles">
                {{ $t("global.upload") }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="close">
            {{ $t("global.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import store from "@/store";
import vue2Dropzone from "vue2-dropzone";
import { dropzoneOptionsFile } from "@/config/Dropzone";
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew.vue";
import AppApi from "@/api/AppApi";
import { LADE_AUSWAHLWERTE_DOKUMENT } from "@/store/dokument/actions.type";

export default {
  name: "FileUploadModal",
  components: {
    vue2Dropzone,
    ModalCloseButtonNew,
  },
  mixins: [modal],
  store,
  props: [
    "id",
    "person",
    "firma",
    "foreigntable",
    "foreignkey",
    "gptyp",
    "aktivitaet",
    "auftrag",
  ],
  data() {
    return {
      numPages: 1,
      actualPage: 1,
      dokumentKategorieId: null,
    };
  },
  watch: {
    dokumentKategorieId(newVal) {
      if (!this.$refs.dokumenteUpload) return;

      if (this.aktivitaet) {
        this.$refs.dokumenteUpload.dropzone.options.url = `${AppApi.defaults.baseURL}/dokumente-reiter?aktivitaetId=${this.aktivitaet}&dokumentKategorieId=${newVal}`;
        return;
      }

      // entweder personId oder firmaId verwenden
      const hasPerson = !!this.person;
      const idParamName = hasPerson ? "personId" : "firmaId";
      const idParamValue = hasPerson ? this.person : this.firma;

      // Falls gar nichts gesetzt ist, lieber abbrechen
      if (!idParamValue) {
        console.warn(
          "Weder person noch firma gesetzt – Upload-URL wird nicht gesetzt."
        );
        return;
      }

      this.$refs.dokumenteUpload.dropzone.options.url = `${AppApi.defaults.baseURL}/dokumente-reiter?${idParamName}=${idParamValue}&dokumentKategorieId=${newVal}`;
    },
  },
  created() {
    this.dokumentKategorieId = "18DF929F700";
    if (this.dokumentKategorien.length === 0)
      this.$store.dispatch(`dokument/${LADE_AUSWAHLWERTE_DOKUMENT}`);
  },
  computed: {
    dropzoneOptions() {
      return dropzoneOptionsFile(
        AppApi.defaults.baseURL + "/dokumente-reiter",
        this.person,
        this.foreigntable,
        this.foreignkey,
        this.gptyp,
        this.dokumentKategorieId,
        this.aktivitaet ? { aktivitaetId: this.aktivitaet } : null
      );
    },
    dokumentKategorien: {
      get() {
        return this.$store.state.dokument.dokumentkategorie;
      },
    },
  },
  methods: {
    close() {
      $(`#${this.id}`).modal("hide");
    },
    uploadFiles() {
      this.$refs.dokumenteUpload.processQueue();
    },
    fileUploaded() {
      $(`#${this.id}`).modal("hide");
      this.$parent.getDokumente(true);
    },
  },
};
</script>

<style></style>
